"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _keyCodes = require("../../helpers/keyCodes");

/*
  Potential Improvements:
    - Base length validation off of cardType
    - Display card type
*/
var EventHandler = /*#__PURE__*/function () {
  function EventHandler(setStateValues) {
    (0, _classCallCheck2["default"])(this, EventHandler);
    this.setStateValues = setStateValues;
    this.displayName = 'CCNumberInputEventHandler';
    this.fourDigitsRegex = /(\d{4})/g;
    this.cardNumMaxLength = 16;
    this.validKeyCodes = [].concat((0, _toConsumableArray2["default"])(_keyCodes.deleteKeys), (0, _toConsumableArray2["default"])(_keyCodes.movementKeys), (0, _toConsumableArray2["default"])(_keyCodes.numericKeys));
  }

  (0, _createClass2["default"])(EventHandler, [{
    key: "formatValue",
    value: function formatValue(value) {
      var storedValue = value.replace(/ /g, '').split(this.fourDigitsRegex).filter(Boolean).map(function (group, i) {
        return group.length === 4 && i < 3 ? "".concat(group, " ") : group;
      }).join('');
      this.setStateValues({
        storedValue: storedValue
      });
    } // Key 'down' is handled to prevent invalid input

  }, {
    key: "onKeyDown",
    value: function onKeyDown(event) {
      var keyCode = event.keyCode,
          value = event.target.value;

      if (_keyCodes.deleteKeys.includes(keyCode) || _keyCodes.movementKeys.includes(keyCode) || (0, _keyCodes.isMetaKeyPressed)(event)) {
        return;
      }

      if (!this.validKeyCodes.includes(keyCode) || value.replace(/ /g, '').length >= this.cardNumMaxLength) {
        event.preventDefault();
      }
    } // Key 'up' is handled to format existing storedValue from state

  }, {
    key: "onKeyUp",
    value: function onKeyUp(event) {
      var keyCode = event.keyCode,
          value = event.target.value;

      if (_keyCodes.deleteKeys.includes(keyCode)) {
        return;
      }

      this.formatValue(value);
    } // Change is handled to set storedValue in state

  }, {
    key: "onChange",
    value: function onChange(event) {
      this.setStateValues({
        storedValue: event.target.value
      });
    }
  }, {
    key: "onBlur",
    value: function onBlur(event) {
      // https://reactjs.org/docs/events.html#event-pooling
      event.persist();
      this.setStateValues({
        dirty: event.target.value.length > 0,
        complete: true,
        isFocused: false
      });
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      this.setStateValues({
        dirty: true,
        isFocused: true
      });
    }
  }]);
  return EventHandler;
}();

var _default = EventHandler;
exports["default"] = _default;